<template>
	<svg :width="width" :height="height" viewBox="0 0 41 37" role="presentation" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M20.5204387,37 C26.8973081,37 31.8298438,35.444881 35.3180459,32.334643 C38.8062479,29.224405 40.6866068,24.921909 40.9591226,19.4271552 C41.0136258,18.8051076 41.0136258,18.1948924 40.9591226,17.5728448 C40.6866068,12.1299283 38.7789963,7.84039167 35.2362911,4.704235 C31.6935859,1.56807833 26.7883018,0 20.5204387,0 C14.1980724,0 9.26553672,1.56807833 5.72283151,4.704235 C2.18012629,7.84039167 0.272515786,12.1299283 0,17.5728448 L0,19.4271552 C0.272515786,24.921909 2.15287471,29.224405 5.64107677,32.334643 C9.12927883,35.444881 14.0890661,37 20.5204387,37 Z"
			class="bg"
			fill="#FF3D37"
		></path>
		<g transform="translate(13.000000, 12.000000)" fill="#000000" id="social/twitter">
			<path
				d="M17,1.63936957 C16.3747187,1.9173913 15.7021563,2.10540217 14.9966562,2.19008696 C15.7170312,1.75707609 16.2700625,1.0721413 16.530375,0.255652174 C15.85675,0.656173913 15.1098125,0.946978261 14.3155938,1.10409783 C13.6791562,0.42448913 12.7728438,0 11.7698437,0 C9.84353125,0 8.2821875,1.56533696 8.2821875,3.49657609 C8.2821875,3.77033696 8.313,4.03717391 8.3725,4.2933587 C5.47346875,4.14742391 2.9038125,2.75518478 1.183625,0.639663043 C0.88346875,1.15629348 0.71134375,1.75707609 0.71134375,2.39780435 C0.71134375,3.61055435 1.3270625,4.68109783 2.26259375,5.30797826 C1.69096875,5.28986957 1.15334375,5.13275 0.6831875,4.87070652 C0.68265625,4.88561957 0.68265625,4.9 0.68265625,4.91491304 C0.68265625,6.6091413 1.884875,8.02215217 3.48075,8.34331522 C3.18803125,8.42320652 2.87990625,8.46581522 2.5616875,8.46581522 C2.33696875,8.46581522 2.118625,8.44397826 1.90559375,8.4035 C2.3491875,9.79254348 3.63746875,10.8034348 5.16375,10.831663 C3.97003125,11.769587 2.4660625,12.3282935 0.8319375,12.3282935 C0.550375,12.3282935 0.2730625,12.3117826 0,12.2798261 C1.54328125,13.2715435 3.376625,13.8504891 5.3465,13.8504891 C11.761875,13.8504891 15.2697187,8.52227174 15.2697187,3.9018913 C15.2697187,3.75009783 15.2665312,3.59936957 15.259625,3.44917391 C15.9412188,2.95651087 16.5325,2.34081522 17,1.63936957"
				id="twitter"
			></path>
		</g>
	</svg>
</template>

<script>
export default {
	props: {
		type: {
			type: String,
			ddefault: "",
		},
		width: {
			type: Number,
			default: 41,
		},
		height: {
			type: Number,
			default: 37,
		},
		fill: {
			type: String,
			default: "#FF3D37",
		},
	},
};
</script>

<style scoped>
path {
	transition: all 0.3s;
}
</style>
